<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout justify-center wrap>
            <v-flex md12>
                <material-card
                    color="green"
                    :title="getTitle()"
                    class="grid-card"
                >
                    <div v-if="dataSource.isLoading()">
                        {{ startLoading() }}
                    </div>
                    <div v-if="dataSource.isLoaded()">
                        {{ finishLoading() }}
                    </div>
                    <DxDataGrid
                        class="mt-3 dxgrid-custom"
                        :data-source="dataSource"
                        :allow-column-reordering="true"
                        :allow-column-resizing="true"
                        column-resizing-mode="nextColumn"
                        :column-min-width="50"
                        :on-row-click="goToAccount"
                        :column-auto-width="true"
                        :customize-export-data="customizeExportData"
                        @toolbar-preparing="onToolbarPreparing($event)"
                        @initialized="saveGridInstance"
                    >
                        <DxLoadPanel :enabled="false"> </DxLoadPanel>
                        <DxExport
                            :enabled="true"
                            :allow-export-selected-data="true"
                            :customize-excel-cell="customizeExcelCell"
                            file-name="Accounts"
                        />
                        <DxPaging :page-size="20" />
                        <DxPager
                            :show-page-size-selector="true"
                            :allowed-page-sizes="pageSizes"
                            :show-info="true"
                        />
                        <DxFilterRow :visible="true" />
                        <DxStateStoring
                            :enabled="true"
                            type="custom"
                            storage-key="accounts"
                            :customSave="saveGrid"
                            :customLoad="loadGrid"
                        />
                        <DxHeaderFilter :visible="true" />
                        <DxSearchPanel
                            :visible="true"
                            :width="240"
                            placeholder="Search..."
                        />
                        <DxColumn
                            v-for="column in columns"
                            :data-field="column.field"
                            :caption="column.label"
                            :data-type="column.type"
                            :format="column.format"
                            :cell-template="column.template"
                            :visible="column.visible"
                            :filter-type.sync="column.filterType"
                            :filter-values.sync="column.filterValues"
                            :filter-value.sync="column.filterValue"
                            :selected-filter-operation.sync="
                                column.selectedOperation
                            "
                        />
                        <DxColumnChooser
                            :enabled="true"
                            :allow-search="true"
                            mode="dragAndDrop"
                        />
                        <template #link-cell-template="{ data }">
                            <router-link
                                :to="{
                                    name: 'Account View',
                                    params: {
                                        id: data.data.accountID
                                    }
                                }"
                                >{{ data.data.accountID }}</router-link
                            >
                        </template>
                        <template #reset-all-filters="{ data }">
                            <v-btn
                                v-if="columns.some(hasFilter)"
                                @click="clearAllFilter"
                                dark
                                class="mx-2"
                                small
                                color="default"
                            >
                                Reset Filter
                            </v-btn>
                        </template>
                        <template #filter-tags="{ data }">
                            <div>
                                <v-chip
                                    v-for="filter in columns.filter(hasFilter)"
                                    @input="clearFilter(filter)"
                                    close
                                    ><div class="font-weight-medium">
                                        {{ getFilterLabel(filter.field) }}
                                    </div>
                                    : {{ getFilterValue(filter) }}</v-chip
                                >
                            </div>
                        </template>
                    </DxDataGrid>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import DxButton from "devextreme-vue/button";
import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxExport,
    DxPaging,
    DxPager,
    DxStateStoring,
    DxColumnChooser,
    DxLoadPanel
} from "devextreme-vue/data-grid";
import { formatCurrency, getDomain } from "../utils/helpers.js";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import moment from "moment";

const dataSource = new DataSource({
    store: new ODataStore({
        version: 4,
        url: getDomain() + "/odata/accounts"
    })
    // Other DataSource options go here
});

export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxHeaderFilter,
        DxSearchPanel,
        DxFilterRow,
        DxExport,
        DxPaging,
        DxPager,
        DxStateStoring,
        DxColumnChooser,
        DxLoadPanel
    },
    data: () => ({
        title: "Accounts",
        pageSizes: [20, 100, 200],
        dataSource,
        // dataSource: {
        //     store: {
        //         type: "odata",
        //         version: 4,
        //         url: getDomain() + "/odata/accounts"
        //     },
        //     select: [
        //         "name",
        //         "accountID",
        //         "hname",
        //         "homePhone",
        //         "cellPhone",
        //         "address1",
        //         "emailAddress",
        //         "activeSchedules",
        //         "totalScheduledAmount",
        //         "tuitionBalance",
        //         "transportationBalance",
        //         "accountLinkID",
        //         "father",
        //         "shver",
        //         "pinNum",
        //         "lastSuccessfulSchedule",
        //         "nextScheduleDate",
        //         "lastUpdated",
        //         "lastLoggedIn"
        //     ]
        //     //filter: ['Product_Current_Inventory', '>', 0]
        // },
        filters: [],
        grid: "",
        columns: [
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: "",
                selectedOperation: null
            },
            {
                field: "accountID",
                label: "Account ID",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "hname",
                label: "Hebrew Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "homePhone",
                label: "Home Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "cellPhone",
                label: "Cellphone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "emailAddress",
                label: "Email",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "activeSchedules",
                label: "Active Schedules",
                type: "number",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "totalScheduledAmount",
                label: "Total Scheduled Amount",
                type: "number",
                format: "currency",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "tuitionBalance",
                label: "Tuition Balance",
                type: "number",
                format: "currency",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "transportationBalance",
                label: "Transportation Balance",
                type: "number",
                format: "currency",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "accountLinkID",
                label: "Account Link ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "father",
                label: "Father",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "shver",
                label: "Shver",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "pinNum",
                label: "Pin Number",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "lastSuccessfulSchedule",
                label: "Last Successful Schedule",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "nextScheduleDate",
                label: "Next Schedule Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "lastUpdated",
                label: "Last Updated",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            },
            {
                field: "lastLoggedIn",
                label: "Last Logged In",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedOperation: null
            }
        ],

        filterOperaters: new Map([
            ["startswith", "Starts With"],
            ["endswith", "Ends with"],
            ["notcontains", "Not Contains"],
            ["contains", "Contains"],
            ["<>", "Do not equal"],
            ["=", "Equals"],
            ["<", "Less than"],
            [">", "Greater than"],
            ["<=", "Less than or equal to"],
            [">=", "Greater than or equal to"],
            ["between", "Between"]
        ])
    }),
    methods: {
        getTitle() {
            const count =
                this.dataSource.totalCount() > 0
                    ? this.dataSource.totalCount()
                    : 0;

            return `Accounts (${count})`;
        },
        goToAccount(event) {
            this.$router.push({
                name: "Account View",
                params: { id: event.data.accountID }
            });
        },
        startLoading() {
            this.$Progress.start();
        },
        finishLoading() {
            this.$Progress.finish();
        },
        saveGridInstance(e) {
            this.grid = e.component;
        },
        saveGrid(state) {
            localStorage.setItem("accounts2", JSON.stringify(state));
        },
        loadGrid() {
            let state = localStorage.getItem("accounts2");

            if (state) {
                state = JSON.parse(state);

                state.columns.forEach(filter => {
                    const column = this.columns.find(
                        c => c.field == filter.dataField
                    );

                    if (!column) return;

                    column.filterValue = this.hasValue(filter.filterValue)
                        ? filter.filterValue
                        : column.filterValue;
                    column.filterValues = this.hasValue(filter.filterValues)
                        ? filter.filterValues
                        : column.filterValues;
                    column.selectedFilterOperation = this.hasValue(
                        filter.selectedFilterOperation
                    )
                        ? filter.selectedFilterOperation
                        : column.selectedFilterOperation;
                });
            }

            return state;
        },
        clearFilter(filter) {
            filter.filterValue = null;
            filter.filterValues = [];
            filter.selectedOperation = null;
        },
        clearAllFilter(filter) {
            this.grid.clearFilter();
        },
        hasFilter(column) {
            return (
                column.filterValue ||
                (column.filterValues && column.filterValues.length)
            );
        },
        hasValue(value) {
            if (value === false) return true;

            return value;
        },
        getFilterLabel(field) {
            const column = this.columns.find(c => c.field == field);

            return column ? column.label : field;
        },
        getFilterOperation(filter) {
            return filter.selectedOperation
                ? (this.filterOperaters.get(filter.selectedOperation) ||
                      filter.selectedOperation) + ": "
                : "";
        },
        getFilterValue(filter) {
            const operation = this.getFilterOperation(filter);

            if (filter.type == "date") {
                if (filter.filterValues && filter.filterValues.length)
                    return (
                        "In: " +
                        filter.filterValues
                            .map(value => moment(value).format("L"))
                            .join(", ")
                    );

                if (filter.selectedOperation == "between") {
                    return (
                        operation +
                        filter.filterValue
                            .map(d => moment(d).format("L"))
                            .join(" - ")
                    );
                }

                return operation + moment(filter.filterValue).format("L");
            }

            if (filter.filterValues && filter.filterValues.length)
                return "In: " + filter.filterValues.join(", ");

            return operation + filter.filterValue;
        },
        onToolbarPreparing(e) {
            e.toolbarOptions.items.unshift(
                {
                    location: "before",
                    template: "filter-tags"
                },
                {
                    location: "after",
                    sortIndex: 0,
                    template: "reset-all-filters"
                }
            );
        },
        customizeExcelCell(options) {
            // const gridCell = options.gridCell;
            // if (!gridCell) {
            //     return;
            // }
            // if (
            //     gridCell.column.dataType === "string" ||
            //     gridCell.column.dataType
            // ) {
            //     options.numberFormat = "@";
            // }
        },
        customizeExportData(columns, rows) {
            rows.forEach(function(row) {
                let rowValues = row.values;
                for (let i = 0; i < rowValues.length; i++) {
                    if (rowValues[i] == "") rowValues[i] = "";
                    if (
                        /[^\x20-\x7F]/.test(rowValues[i]) &&
                        !/[\u0590-\u05FF]/.test(rowValues[i])
                    ) {
                        rowValues[i] = "";
                    }
                }
            });
        }
    }
};
</script>
<style>
.dxgrid-custom tr:nth-child(even) {
    background-color: rgba(51, 68, 109, 0.03);
}
.dxgrid-custom tr {
    cursor: pointer;
}
.dxgrid-custom .dx-datagrid .dx-row > td {
    font-size: 16px;
    /*    text-align: left !important;*/
    padding: 0.75em 0.75em 0.75em 0.75em;
}
.dxgrid-custom .dx-datagrid .dx-column-lines > td {
    border-left: unset !important;
    border-right: unset !important;
}
.dxgrid-custom .dx-datagrid-focus-overlay {
    border: 2px solid #5cb860;
}
.dxgrid-custom .dx-datagrid-search-text {
    color: #fff;
    background-color: #5cb860;
}

.reset-filter-button .dx-button-content {
    background-color: #999 !important;
    color: #fff !important;
    text-transform: uppercase !important;
}
</style>
